import { render, staticRenderFns } from "./notification_center.vue?vue&type=template&id=37905a3c&scoped=true&"
import script from "./notification_center.vue?vue&type=script&lang=js&"
export * from "./notification_center.vue?vue&type=script&lang=js&"
import style0 from "./notification_center.vue?vue&type=style&index=0&id=37905a3c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37905a3c",
  null
  
)

export default component.exports